/**
 * Chevron — small down-arrow icon used by collapsible pickers
 * (AttributePicker, SupplierPicker, GroupsPicker, …). Rotates 180°
 * when `open` is true to indicate "click to collapse."
 *
 * Replaces the local `function Chevron` redeclared in 4 form modals
 * (purged 2026-05-19).
 */

interface ChevronProps {
  readonly open: boolean
}

export function Chevron({ open }: ChevronProps): JSX.Element {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      aria-hidden
      className={`transition-transform duration-150 ${open ? 'rotate-180' : ''}`}
    >
      <path d="M3 4.5L6 7.5L9 4.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  )
}
